import { Outlet } from 'react-router-dom';
import usePostHogPageview from 'hooks/usePostHogPageview';

// Pathless layout that wraps the entire route tree so PostHog pageview tracking runs on every
// route, including the unauthenticated login/password-reset routes that sit outside UserProvider.
const RootLayout = (): JSX.Element => {
  usePostHogPageview();
  return <Outlet />;
};

export default RootLayout;
